export default {
  id: 123,
  title: 'Target #123 - Snake',
  url: 'https://cssbattle.dev/play/123',
  colors: ['#C74E4E', '#E0E246', '#FFFFFF'],
  solution:
    '<a a><a b><style>[a],[b]{top:90;left:90;width:20;height:20}body{background:#c74e4e}a{position:fixed}[a]{background:#fff;border-radius:9in}[b]{color:#e0e246;border-radius:5px;box-shadow:0 100px,25px 100px,50px 100px,75px 100px,100px 100px,125px 100px,150px 100px,175px 100px,200px 100px,200px 75px,200px 50px,200px 25px,200px 0,100px 0,125px 0,150px 0,175px 0}</style>',
}
